import React, { useEffect, useState } from "react";
import useMutation from "../../../../../hooks/useMutation";
import { scholarShipApply } from "../../../../../services/applicationFormService";
import { toast } from "react-toastify";
import Button from "../../../../form/Button";
import DynamicField from "../../../../form/DynamicField";
import useForm from "../../../../../hooks/useForm";

const CertificationFormFront = ({
  backHandler = () => {},
  close = () => {},
  data,
  details,
  loaded,
  setLoaded = () => {},
  StaticLabel = "Applicant Consent",
  isSubmitted,
  setIsSubmitted = () => {},
  scholarshipId,
}) => {
  const [fieldConfigs, setFieldConfigs] = useState([]);

  useEffect(() => {
    if (data) {
      setLoaded(true);
      const updatedFields =
        data?.data?.map((item, index) => ({
          ...item,
          name: item.name || `field_${index}`,
          type: item?.type || "",
          label: item?.label || "",
          placeholder: item?.placeholder || "",
          isRequired: item?.isRequired || false,
        })) || [];

      const initialValues = {};
      updatedFields.forEach((field) => {
        initialValues[field.name] = field?.fieldValue ?? "";
      });

      setFieldConfigs(updatedFields);
      setFieldsValue(initialValues);
      setLoaded(false);
    }
  }, [data]);

  const {
    values,
    handleChange,
    handleSubmit,
    errors,
    setFieldsValue,
    formValidate,
  } = useForm({
    validationRules: Object.assign(
      {},
      ...fieldConfigs?.map((item) => {
        const rules = [];

        if (item?.isRequired) {
          rules.push({
            required: true,
            message: `${item?.label} is required`,
          });
        }

        if (item?.type?.toLowerCase() === "email") {
          rules.push({
            type: "email",
            message: `${item?.label} must be a valid email address`,
          });
        }

        return {
          [item?.name]: rules,
        };
      })
    ),
  });

  const areAnyRequiredFieldsEmpty = fieldConfigs.some(
    (field) => field?.isRequired && !values?.[field.name]
  );

  const { mutate, error, isLoading } = useMutation({
    mutationFn: async (val) => {
      setLoaded(true);
      const structuredData = fieldConfigs?.map((field) => ({
        fieldId: field._id || field.id,
        label: field.label,
        value: values?.[field.name] || "",
      }));
      return await scholarShipApply({
        groupCodeData: structuredData,
        scholarshipId: scholarshipId,
        groupCode: data?._id,
        formId: details?.applicationFormId,
        type: val?.type,
      });
    },
    onSuccess: (res) => {
      setLoaded(false);
      if (res?.isFormSubmitted && res?.type === "save") {
        // toast.success("Application Submitted Successfully!");
        setIsSubmitted({ type: "save", submitted: true });
      } else if (res?.isFormSubmitted && res?.type !== "save") {
        setIsSubmitted({ type: "", submitted: true });
      } else {
        toast.error("Something went wrong");
      }
    },
    onError: (error) => {
      toast.error("Submission failed");
      setLoaded(false);
    },
  });
  return (
    <>
      {loaded ? (
        <div className="text-center font-semibold">Loading...</div>
      ) : isSubmitted?.submitted ? (
        isSubmitted?.type === "save" ? (
          <div className="text-center">
            {/* <h2 className="text-2xl font-semibold text-green-600 mb-4">
              💾 Progress Saved
            </h2> */}
            <p className="text-gray-700">
              Your progress has been saved. You can resume your application
              anytime.
            </p>
          </div>
        ) : (
          <div className="text-center">
            {/* <h2 className="text-2xl font-semibold text-chestnut-rose mb-4">
              🎉 Application Submitted Successfully!
            </h2> */}
            <p className="text-gray-700">
              Thank you! Your application was submitted. Check your status
              online— no need to contact us. A confirmation email is on the way.
            </p>
          </div>
        )
      ) : (
        <form
          onSubmit={(event) =>
            handleSubmit(event, () => mutate({ type: "submit" }))
          }
        >
          <div className="gap-4">
            {fieldConfigs?.map((f, i) => (
              <DynamicField
                key={i}
                type={f.type?.toLowerCase()}
                name={f.name}
                label={f.label}
                placeholder={f.placeholder}
                value={values?.[f.name] || ""}
                dropdownData={f.options || []}
                onChange={handleChange}
                uploadFile={f.uploadFile}
                uploadButtonText={f.uploadButtonText}
                {...formValidate(errors, f.name)}
                StaticLabel={StaticLabel}
              />
            ))}
          </div>

          <div className="my-6 md:mt-12 flex flex-col sm:flex-row justify-center gap-2 md:gap-4">
            <Button
              buttonType="button"
              buttonLabel="Back"
              buttonClasses="!rounded-full !px-5 md:!px-8 md:!h-12 !border !border-chestnut-rose !bg-transparent !text-chestnut-rose hover:!bg-chestnut-rose hover:!text-white"
              buttonLabelClasses="mx-auto !text-xs md:!text-lg xl:!text-xl"
              buttonFunction={backHandler}
            />
            <Button
              buttonType="submit"
              buttonLabel="Submit Application"
              buttonClasses="!rounded-full !px-5 md:!px-8 md:!h-12 !border !border-chestnut-rose !bg-transparent !text-chestnut-rose hover:!bg-chestnut-rose hover:!text-white"
              buttonLabelClasses="mx-auto !text-lg xl:!text-xl"
              isDisable={loaded}
            />
            <Button
              buttonType={areAnyRequiredFieldsEmpty ? "submit" : "button"}
              buttonLabel="Save & Resume Later"
              buttonClasses="!rounded-full !px-5 md:!px-8 md:!h-12 !border !border-chestnut-rose !bg-transparent !text-chestnut-rose hover:!bg-chestnut-rose hover:!text-white"
              buttonLabelClasses="mx-auto !text-xs md:!text-lg xl:!text-xl"
              isDisable={loaded}
              buttonFunction={() => {
                if (areAnyRequiredFieldsEmpty) {
                  toast.error("Please fill all required fields before saving.");
                  return;
                }
                mutate({ ...values, type: "save" });
              }}
            />
          </div>
        </form>
      )}
    </>
  );
};

export default CertificationFormFront;
